module.exports = __webpack_public_path__ + "static/androidBannerTyres-a16c8c9ebc50278122c591d7f05f7c13.jpg";